module.exports = __webpack_public_path__ + "static/media/travelimage2.eeb764f0.jpg";